import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class StcLetterReply extends Controller {
  static values = { isLetter: Boolean, isReply: Boolean };
  static targets = ['tab', 'tabContainer', 'content', 'marker', 'unmarker', 'sequence'];
  static isShuffled = false;

  static letterReplyMatch = [
    {
      letterTabId: 0,
      replyTabId: [0, 1],
    },
    {
      letterTabId: 1,
      replyTabId: 2,
    },
    {
      letterTabId: 2,
      replyTabId: 3,
    },
    {
      letterTabId: 3,
      replyTabId: 4,
    },
    {
      letterTabId: 4,
      replyTabId: 5,
    },
    {
      letterTabId: 5,
      replyTabId: 6,
    },
  ];
  #selectedIdx;

  static getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  shuffle(array) {
    array.sort(() => Math.random() - 0.5);
  }

  initialize() {
    if (!StcLetterReply.isShuffled) {
      this.shuffle(StcLetterReply.letterReplyMatch);
      StcLetterReply.isShuffled = true;
    }
  }

  connect() {
    // 편지지와 답장 랜덤으로 배치
    this.renderAllTabs();
    // 편지지 탭 번호 매기기
    this.renderSequence();
    // 첫번째 탭 선택하기
    this.tabTargets.forEach((tab) => this.unMarkTab(tab));
    this.renderTabAndContentByTabId(this.getFirstTabId());

    // 탭 클릭 시, 연결된 편지와 답장 선택
    window.addEventListener('renderTabEvent', (evt) => {
      // { isLetter: true, tabId: letterTabId}
      if (this.isLetterValue === Boolean(evt.detail.isLetter)) {
        this.renderTabAndContentByTabId(Number(evt.detail.tabId));
      }
    });
  }

  getLetterIdByReplyId(replyId) {
    const found = StcLetterReply.letterReplyMatch.find((obj) => {
      if (obj.replyTabId instanceof Array) {
        const replyIds = obj.replyTabId;
        const reply = replyIds.find((id) => id === Number(replyId));
        return reply !== undefined;
      }
      return obj.replyTabId === Number(replyId);
    });
    return found.letterTabId;
  }

  getReplyIdByLetterId(letterId) {
    const found = StcLetterReply.letterReplyMatch.find((obj) => obj.letterTabId === Number(letterId));
    if (found.replyTabId instanceof Array) {
      const relyTabIds = found.replyTabId;
      const randomIdx = StcLetterReply.getRandomInt(0, relyTabIds.length - 1);
      return relyTabIds[randomIdx];
    }
    return found.replyTabId;
  }

  getFirstTabId() {
    return Number(
      this.tabContainerTarget
        .querySelectorAll('[data-stc-letter-reply-target="tab"]')[0]
        .getAttribute('data-stc-letter-reply-id-param'),
    );
  }

  // 편지지 번호 매기기
  renderSequence() {
    if (!this.isLetterValue) return;
    const tabs = this.getAllTabs();
    for (let i = 0; i < tabs.length; i++) {
      const sequence = i + 1;
      tabs[i]
        .querySelectorAll('[data-stc-letter-reply-target="sequence"]')
        .forEach((element) => (element.innerText = sequence));
    }
  }

  renderAllTabs() {
    for (let i = 0; i < StcLetterReply.letterReplyMatch.length; i++) {
      const match = StcLetterReply.letterReplyMatch[i];
      if (this.isLetterValue) {
        this.renderTab(match.letterTabId);
      } else {
        this.renderTab(match.replyTabId);
      }
    }
  }

  renderTab(tabId) {
    if (tabId instanceof Array) {
      const tabIds = tabId;
      this.shuffle(tabIds);
      tabIds.forEach((id) => {
        const tab = this.getTabByTabId(id);
        if (tab === undefined) return;
        this.tabContainerTarget.prepend(tab);
      });
    } else {
      const tab = this.getTabByTabId(tabId);
      if (tab === undefined) return;
      this.tabContainerTarget.prepend(tab);
    }
  }

  getContentByTabId(tabId) {
    for (let i = 0; i < this.contentTargets.length; i++) {
      if (this.contentTargets[i].getAttribute('data-stc-letter-reply-linked-id') == tabId) {
        return this.contentTargets[i];
      }
    }
  }

  isSameContent(c1, c2) {
    const c1TabId = c1.getAttribute('data-stc-letter-reply-linked-id');
    const c2TabId = c2.getAttribute('data-stc-letter-reply-linked-id');
    return Number(c1TabId) === Number(c2TabId);
  }

  getTabByTabId(tabId) {
    for (let i = 0; i < this.tabTargets.length; i++) {
      if (this.tabTargets[i].getAttribute('data-stc-letter-reply-id-param') == tabId) {
        return this.tabTargets[i];
      }
    }
  }

  isSameTab(t1, t2) {
    const t1TabId = t1.getAttribute('data-stc-letter-reply-id-param');
    const t2TabId = t2.getAttribute('data-stc-letter-reply-id-param');
    return Number(t1TabId) === Number(t2TabId);
  }

  getTabByTabId(tabId) {
    for (let i = 0; i < this.tabTargets.length; i++) {
      if (this.tabTargets[i].getAttribute('data-stc-letter-reply-id-param') == tabId) {
        return this.tabTargets[i];
      }
    }
  }

  getAllTabs() {
    return this.element
      .querySelector('[data-stc-letter-reply-target="tabContainer"]')
      .querySelectorAll('[data-stc-letter-reply-target="tab"]');
  }

  selectTab(e) {
    const selectTabId = Number(e.params.id);
    let letterTabId;
    let replyTabId;
    if (this.isLetterValue) {
      letterTabId = selectTabId;
      replyTabId = this.getReplyIdByLetterId(letterTabId);
    } else if (this.isReplyValue) {
      replyTabId = selectTabId;
      letterTabId = this.getLetterIdByReplyId(replyTabId);
    } else {
      console.error(e);
      return;
    }

    console.log(`letterTabId: ${letterTabId}, replyTabId: ${replyTabId}`);
    window.dispatchEvent(
      new CustomEvent('renderTabEvent', {
        detail: { isLetter: true, tabId: letterTabId },
      }),
    );

    window.dispatchEvent(
      new CustomEvent('renderTabEvent', {
        detail: { isLetter: false, tabId: replyTabId },
      }),
    );

    this.scrollToTarget(this.getTabByTabId(selectTabId));
  }

  renderTabAndContentByTabId(tabId) {
    const selectedContent = this.getContentByTabId(tabId);
    const selectedTab = this.getTabByTabId(tabId);

    this.tabTargets.filter((t) => !this.isSameTab(t, selectedTab)).forEach((tab) => this.unMarkTab(tab));
    this.markTab(selectedTab);

    this.contentTargets
      .filter((c) => !this.isSameContent(c, selectedContent))
      .forEach((content) => this.disableContent(content));
    this.enableContent(selectedContent);
    this.triggerTypeText(tabId);
    // this.focus(selectedTab);
  }

  scrollToTarget(element) {
    const navHeight = $(document.getElementById('nav')).outerHeight();
    const offsetTop = $(element).offset().top;
    const scrollTop = offsetTop - navHeight - 10;

    $('html, body').animate(
      {
        scrollTop,
      },
      500,
    );

    return false;
  }

  enableContent(content) {
    content.classList.remove('hidden');
    const video = content.querySelector('.video-container iframe');
    if (video === null) return;
    if (video.getAttribute('src').length === 0) {
      video.src = video.getAttribute('data-src');
    }
  }

  disableContent(content) {
    content.classList.add('hidden');
    const video = content.querySelector('.video-container iframe');
    if (video === null) return;
    video.src = '';
  }

  triggerTypeText(tabId) {
    if (!this.isReplyValue) return;
    const accordionContentShowEvent = new CustomEvent('accordionContentShowEvent', {
      detail: { selectedIdx: tabId },
    });
    window.dispatchEvent(accordionContentShowEvent);
  }

  markTab(tab) {
    tab.querySelector('[data-stc-letter-reply-target="marker"]').classList.remove('hidden');
    tab.querySelector('[data-stc-letter-reply-target="unmarker"]').classList.add('hidden');
  }

  unMarkTab(tab) {
    tab.querySelector('[data-stc-letter-reply-target="marker"]').classList.add('hidden');
    tab.querySelector('[data-stc-letter-reply-target="unmarker"]').classList.remove('hidden');
  }

  // focus(element) {
  //   if (this.isLetterValue) return;
  //   const container = document.querySelector("div[data-horizontal-scroll-button-target='scrollContainer']");
  //   const pos = ($(element).offset().left + $(element).offset().right) / 2;
  //   console.log(pos);
  //   container.scrollLeft = pos;
  //   // element.scrollIntoView({ inline: 'center', block: 'nearest' });
  // }
}
